import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx, css } from '@emotion/react';
import { overflowShadow, relativeFontSizeToBase16 } from '@atlaskit/editor-shared-styles';
import { N20 } from '@atlaskit/theme/colors';
import { fontSize } from '@atlaskit/theme/constants';
import { CodeBlockSharedCssClassName } from '@atlaskit/editor-common/styles';
import CodeBlockButtonContainer from './codeBlockButtonContainer';

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
var codeBlockStyleOverrides = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\ttab-size: 4;\n\tbackground-color: ", ";\n\n\t&:hover {\n\t\tbutton {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\tbutton {\n\t\topacity: 0;\n\t\ttransition: opacity 0.2s ease 0s;\n\t}\n\n\t", " {\n\t\tfont-size: ", ";\n\t\tline-height: 1.5rem;\n\t\tbackground-image: ", ";\n\t\tbackground-attachment: local, local, local, local, scroll, scroll, scroll, scroll;\n\t\tbackground-position:\n\t\t\t0 0,\n\t\t\t0 0,\n\t\t\t100% 0,\n\t\t\t100% 0,\n\t\t\t100% 0,\n\t\t\t100% 0,\n\t\t\t0 0,\n\t\t\t0 0;\n\t}\n"])), "var(--ds-surface-raised, ".concat(N20, ")"), CodeBlockSharedCssClassName.DS_CODEBLOCK, relativeFontSizeToBase16(fontSize()), overflowShadow({
  leftCoverWidth: "var(--ds-space-300, 24px)"
}));
var CodeBlockContainer = function CodeBlockContainer(_ref) {
  var allowCopyToClipboard = _ref.allowCopyToClipboard,
    allowWrapCodeBlock = _ref.allowWrapCodeBlock,
    children = _ref.children,
    className = _ref.className,
    setWrapLongLines = _ref.setWrapLongLines,
    text = _ref.text,
    wrapLongLines = _ref.wrapLongLines;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    jsx("div", {
      className: className,
      css: codeBlockStyleOverrides
    }, jsx(CodeBlockButtonContainer, {
      allowCopyToClipboard: allowCopyToClipboard,
      allowWrapCodeBlock: allowWrapCodeBlock,
      setWrapLongLines: setWrapLongLines,
      text: text,
      wrapLongLines: wrapLongLines
    }), children)
  );
};
export default CodeBlockContainer;